/* eslint-disable indent */
/* eslint-disable no-multi-spaces */
/* Datastructure id and identifier components */

// Import libraries
const { StatusCodes } = require('http-status-codes');
const Joi = require('joi');
const { TERMINATE } = require('@bcm/constants');
const T = TERMINATE;

// Define datastruct component constants
const ids = {
  annotationId:           'createdAt',
  appointmentId:          'uuid',
  appointmentResponseId:  'uuid',
  bodySiteId:             'uuid',
  imageSetId:             'uuid',
  eocId:                  'createdAt',
  clinicalImpressionId:   'createdAt',
  conditionId:            'uuid',
  workspaceId:            'parentUuid', // Because of 1:1 relationship between a workspace and an eoc, team, org or user, the workspaceId is the parentId
  channelId:              'createdAt',
  messageId:              'createdAt',
  imageId:                'createdAt',
  orgId:                  'name_uuid',
  scheduleId:             'UTC_day_start',
  slotId:                 'start',
  userId:                 'uuid',
  userSub:                'uuid',
  qualificationId:        'createdAt',
  websocketConnectionId:  'createdAt',
  notificationId:         'createdAt',
  typeId:                 'parentUuid',
  roomId:                 'uuid',
  pageId:                 'createdAt-uuid',
  bookId:                 'createdAt-uuid',
  conferenceRoomId:       'uuid',
  dictationRoomId:        'uuid',
  tag:                    'tag',
  teamId:                 'createdAt',
  libraryId:              'uuid',
};


// ##############
// ---- AUTH ----
// ##############

const authUser = {
  pk: 'AUTHUSERCONTACTS',
  sk: 'STATE#state#AUTHUSERCONTACT#contact#DATA',
  gsiPk: 'AUTHUSERIDS',
  gsiSk: 'STATE#state#AUTHUSERID#userId#DATA',
  buildPk: () => 'AUTHUSERCONTACTS',
  buildSk: (state, contact) => `STATE#${state}#AUTHUSERCONTACT#${contact}#DATA`,
  buildGsiPk: () => 'AUTHUSERIDS',
  buildGsiSk: (state, userId) => `STATE#${state}#AUTHUSERID#${userId}DATA`,
  buildQuerySk: (state, contact) => (
    (state && contact && contact !== T) ? `STATE#${state}#USERCONTACT#${contact}`
  : (state && contact && contact === T) ? `STATE#${state}#USERCONTACT#`
  : (state) ?                             `STATE#${state}`
  :                                       'STATE#'
  ),
  buildQueryGsiSk: (state, userId) => (
    (state && userId && userId !== T) ? `STATE#${state}#AUTHUSERID#${userId}`
  : (state && userId && userId === T) ? `STATE#${state}#AUTHUSERID#`
  : (state) ?                           `STATE#${state}`
  :                                     'STATE#'
  )
};

const authRefreshToken = {
  pk: 'REFRESH#refreshToken',
  sk: 'STATE#state#REFRESHTOKEN#refreshToken#DATA',
  gsiPk: 'AUTHUSERCONTACT#contact#REFRESHTOKEN',
  gsiSk: authUser.sk,
  buildPk: (refreshToken) => `REFRESH#${refreshToken}`,
  buildSk: (state, refreshToken) => `STATE#${state}#REFRESHTOKEN#${refreshToken}#DATA`,
  buildGsiPk: (contact) => `AUTHUSERCONTACT#${contact}#REFRESHTOKEN`,
  buildGsiSk: authUser.buildGsiSk,
  buildQuerySk: (state, refreshToken) => (
    (state && refreshToken && refreshToken !== T) ? `STATE#${state}#REFRESHTOKEN#${refreshToken}`
  : (state && refreshToken && refreshToken === T) ? `STATE#${state}#REFRESHTOKEN#`
  : (state) ?                                       `STATE#${state}`
  :                                                 'STATE#'
  ),
  buildQueryGsiSk: authUser.buildQuerySk,
};

const authForgotPasswordToken = {
  pk: 'AUTHUSERCONTACT#contact#FORGOTPASSWORDTOKEN',
  sk: authUser.sk,
  gsiPk: 'FORGOTPASSWORDTOKEN#forgotPasswordToken',
  gsiSk: 'STATE#state#FORGOTPASSWORDTOKEN#code#DATA',
  buildPk: (contact) => `AUTHUSERCONTACT#${contact}#FORGOTPASSWORDTOKEN`,
  buildSk: authUser.buildSk,
  buildGsiPk: (forgotPasswordToken) => `FORGOTPASSWORDTOKEN#${forgotPasswordToken}`,
  buildGsiSk: (state, forgotPasswordToken) => `STATE#${state}#FORGOTPASSWORDTOKEN#${forgotPasswordToken}#DATA`,
  buildQuerySk: authUser.buildQuerySk,
  buildQueryGsiSk: (state, forgotPasswordToken) => (
    (state && forgotPasswordToken && forgotPasswordToken !== T) ? `STATE#${state}#FORGOTPASSWORDTOKEN#${forgotPasswordToken}`
  : (state && forgotPasswordToken && forgotPasswordToken === T) ? `STATE#${state}#FORGOTPASSWORDTOKEN#`
  : (state) ?                                                     `STATE#${state}`
  :                                                               'STATE#'
  ),
};

const authSessionToken = {
  pk: 'AUTHUSERCONTACT#contact#SESSIONTOKEN',
  sk: authUser.sk,
  buildPk: (contact) => `AUTHUSERCONTACT#${contact}#SESSIONTOKEN`,
  buildSk: authUser.buildSk,
  buildQuerySk: authUser.buildQuerySk,
};

// #############
// ---- ORG ----
// #############

const org = {
  pk: `ORG#${ids.orgId}`,
  sk: `STATE#state#ORG#${ids.orgId}#DATA`,
  buildPk: (orgId) => `ORG#${orgId}`,
  buildSk: (state, orgId) =>            `STATE#${state}#ORG#${orgId}#DATA`,
  buildQuerySk: (state, orgId) => (
      (state && orgId && orgId !== T) ? `STATE#${state}#ORG#${orgId}`
    : (state && orgId && orgId === T) ? `STATE#${state}#ORG#`
    : (state) ?                         `STATE#${state}`
    :                                   'STATE#'
  )
};
const orgs = {
  pk: 'ORG',
  sk: org.sk,
  buildPk: () => 'ORG',
  buildSk: org.buildSk,
  buildQuerySk: org.buildQuerySk,
};

// ##############
// ---- EOC ----
// ##############

const eoc = {
  pk: `EOC#${ids.eocId}`,
  sk: `STATE#state#EOC#${ids.eocId}#DATA`,
  buildPk: (eocId) => `EOC#${eocId}`,
  buildSk: (state, eocId) =>          `STATE#${state}#EOC#${eocId}#DATA`,
  buildQuerySk: (state, eocId) => (
    (state && eocId && eocId !== T) ? `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ? `STATE#${state}#EOC#`
  : (state) ?                         `STATE#${state}`
  :                                   'STATE#'
  )
};
const eocs = {
  pk: 'EOC',
  sk: eoc.sk,
  buildPk: () => 'EOC',
  buildSk: eoc.buildSk,
  buildQuerySk: eoc.buildQuerySk,
};
const eocAnnotation = {
  pk: eoc.pk,
  sk: `STATE#state#EOC#${ids.eocId}#ANNOTAION#${ids.annotationId}#DATA`,
  buildPk: eoc.buildPk,
  buildSk: (state, eocId, annotationId) =>                    `STATE#${state}#EOC#${eocId}#ANNOTATION#${annotationId}#DATA`,
  buildQuerySk: (state, eocId, annotationId) => (
    (state && eocId && annotationId && annotationId !== T) ?  `STATE#${state}#EOC#${eocId}#ANNOTATION#${annotationId}`
  : (state && eocId && annotationId && annotationId === T) ?  `STATE#${state}#EOC#${eocId}#ANNOTATION#`
  : (state && eocId && eocId !== T) ?                         `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                         `STATE#${state}#EOC#`
  : (state) ?                                                 `STATE#${state}`
  :                                                           'STATE#'
  )
};

// ########################
// ---- EOC CONDITION ----
// ########################

const condition = {
  pk: `EOC#${ids.eocId}#CONDITION`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#DATA`,
  buildPk: (eocId) => `EOC#${eocId}#CONDITION`,
  buildSk: (state, eocId, conditionId) =>                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#DATA`,
  buildQuerySk: (state, eocId, conditionId) => (
    (state && eocId && conditionId && conditionId !== T) ?  `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?  `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                       `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                       `STATE#${state}#EOC#`
  : (state) ?                                               `STATE#${state}`
  :                                                         'STATE#'
  )
};
const conditionAnnotation = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#ANNOTATION`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#ANNOTATION#${ids.annotationId}#DATA`,
  buildPk: (eocId, conditionId) => `EOC#${eocId}#CONDITION#${conditionId}#ANNOTATION`,
  buildSk: (state, eocId, conditionId, annotationId) =>                     `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#ANNOTATION#${annotationId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, annotationId) => (
    (state && eocId && conditionId && annotationId && annotationId !== T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#ANNOTATION#${annotationId}`
  : (state && eocId && conditionId && annotationId && annotationId === T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#ANNOTATION#`
  : (state && eocId && conditionId && conditionId !== T) ?                  `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?                  `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                       `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                       `STATE#${state}#EOC#`
  : (state) ?                                                               `STATE#${state}`
  :                                                                         'STATE#'
  )
};

// ##################################
// ---- EOC CLINICAL IMPRESSION ----
// ##################################

const clinicalImpression = {
  pk: `EOC#${ids.eocId}#CLINICALIMPRESSION`,
  sk: `STATE#state#EOC#${ids.eocId}#CLINICALIMPRESSION#${ids.clinicalImpressionId}#DATA`,
  buildPk: (eocId) => `EOC#${eocId}#CLINICALIMPRESSION`,
  buildSk: (state, eocId, clinicalImpressionId) =>                            `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}#DATA`,
  buildQuerySk: (state, eocId, clinicalImpressionId) => (
    (state && eocId && clinicalImpressionId && clinicalImpressionId !== T) ?  `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}`
  : (state && eocId && clinicalImpressionId && clinicalImpressionId === T) ?  `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#`
  : (state && eocId && eocId !== T) ?                                         `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                         `STATE#${state}#EOC#`
  : (state) ?                                                                 `STATE#${state}`
  :                                                                           'STATE#'
  )
};
const clinicalImpressionAnnotation = {
  pk: `EOC#${ids.eocId}#CLINICALIMPRESSION#${ids.clinicalImpressionId}#ANNOTATION`,
  sk: `STATE#state#EOC#${ids.eocId}#CLINICALIMPRESSION#${ids.clinicalImpressionId}#ANNOTATION#${ids.annotationId}#DATA`,
  buildPk: (eocId, clinicalImpressionId) => `EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}#ANNOTATION`,
  buildSk: (state, eocId, clinicalImpressionId, annotationId) =>                      `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}#ANNOTATION#${annotationId}#DATA`,
  buildQuerySk: (state, eocId, clinicalImpressionId, annotationId) => (
    (state && eocId && clinicalImpressionId && annotationId && annotationId !== T) ?  `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}#ANNOTATION#${annotationId}`
  : (state && eocId && clinicalImpressionId && annotationId && annotationId === T) ?  `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}#ANNOTATION#`
  : (state && eocId && clinicalImpressionId && clinicalImpressionId !== T) ?          `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#${clinicalImpressionId}`
  : (state && eocId && clinicalImpressionId && clinicalImpressionId === T) ?          `STATE#${state}#EOC#${eocId}#CLINICALIMPRESSION#`
  : (state && eocId && eocId !== T) ?                                                 `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                                 `STATE#${state}#EOC#`
  : (state) ?                                                                         `STATE#${state}`
  :                                                                                   'STATE#'
  )
};

// #######################
// ---- EOC BODY SITE ----
// #######################

const bodySite = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#BODYSITE`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#BODYSITE#${ids.bodySiteId}#DATA`,
  buildPk: (eocId, conditionId) => `EOC#${eocId}#CONDITION#${conditionId}#BODYSITE`,
  buildSk: (state, eocId, conditionId, bodySiteId) =>                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, bodySiteId) => (
    (state && eocId && conditionId && bodySiteId && bodySiteId !== T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}`
  : (state && eocId && conditionId && bodySiteId && bodySiteId === T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#`
  : (state && eocId && conditionId && conditionId !== T) ?              `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?              `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                   `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                   `STATE#${state}#EOC#`
  : (state) ?                                                           `STATE#${state}`
  :                                                                     'STATE#'
  )
};
const bodySiteAnnotation = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#BODYSITE#${ids.bodySiteId}#ANNOTATION`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#BODYSITE#${ids.bodySiteId}#ANNOTATION#${ids.annotationId}`,
  buildPk: (eocId, conditionId, bodySiteId) => `EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}#ANNOTATION`,
  buildSk: (state, eocId, conditionId, bodySiteId, annotationId) =>                       `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}#ANNOTATION#${annotationId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, bodySiteId, annotationId) => (
    (state && eocId && conditionId && bodySiteId && annotationId && annotationId !== T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}#ANNOTATION#${annotationId}`
  : (state && eocId && conditionId && bodySiteId && annotationId && annotationId === T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}#ANNOTATION#`
  : (state && eocId && conditionId && bodySiteId && bodySiteId !== T) ?                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#${bodySiteId}`
  : (state && eocId && conditionId && bodySiteId && bodySiteId === T) ?                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#BODYSITE#`
  : (state && eocId && conditionId && conditionId !== T) ?                                `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?                                `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                                     `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                                     `STATE#${state}#EOC#`
  : (state) ?                                                                             `STATE#${state}`
  :                                                                                       'STATE#'
  )
};

// ###########################
// ---- EOC IMAGE SET  ----
// ###########################

const imageSet = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET#${ids.imageSetId}#DATA`,
  buildPk: (eocId, conditionId) => `EOC#${eocId}#CONDITION#${conditionId}#IMAGESET`,
  buildSk: (state, eocId, conditionId, imageSetId) =>                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, imageSetId) => (
    (state && eocId && conditionId && imageSetId && imageSetId !== T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}`
  : (state && eocId && conditionId && imageSetId && imageSetId === T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#`
  : (state && eocId && conditionId && conditionId !== T) ?              `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?              `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                   `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                   `STATE#${state}#EOC#`
  : (state) ?                                                           `STATE#${state}`
  :                                                                     'STATE#'
  )
};

// #########################################
// ---- EOC CONDITION IMAGE SET IMAGE ----
// #########################################

const image = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET#${ids.imageSetId}#IMAGE`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET#${ids.imageSetId}#IMAGE#${ids.imageId}#DATA`,
  buildPk: (eocId, conditionId, imageSetId) => `EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE`,
  buildSk: (state, eocId, conditionId, imageSetId, imageId) =>                   `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, imageSetId, imageId) => (
    (state && eocId && conditionId && imageSetId && imageId && imageId !== T) ?  `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}`
  : (state && eocId && conditionId && imageSetId && imageId && imageId === T) ?  `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#`
  : (state && eocId && conditionId && imageSetId && imageSetId !== T) ?       `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}`
  : (state && eocId && conditionId && imageSetId && imageSetId === T) ?       `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#`
  : (state && eocId && conditionId && conditionId !== T) ?                          `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?                          `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                               `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                               `STATE#${state}#EOC#`
  : (state) ?                                                                       `STATE#${state}`
  :                                                                                 'STATE#'
  )
};

// #####################################################
// ---- EOC CONDITION IMAGE SET IMAGE ANNOTATION ----
// #####################################################

const imageAnnotation = {
  pk: `EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET#${ids.imageSetId}#IMAGE#${ids.imageId}#ANNOTATION`,
  sk: `STATE#state#EOC#${ids.eocId}#CONDITION#${ids.conditionId}#IMAGESET#${ids.imageSetId}#IMAGE#${ids.imageId}#ANNOTATION#${ids.annotationId}#DATA`,
  buildPk: (eocId, conditionId, imageSetId, imageId) => `EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}#ANNOTATION`,
  buildSk: (state, eocId, conditionId, imageSetId, imageId, annotationId) =>                         `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}#ANNOTATION#${annotationId}#DATA`,
  buildQuerySk: (state, eocId, conditionId, imageSetId, imageId, annotationId) => (
    (state && eocId && conditionId && imageSetId && imageId && annotationId && annotationId !== T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}#ANNOTATION#${annotationId}`
  : (state && eocId && conditionId && imageSetId && imageId && annotationId && annotationId === T) ? `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}#ANNOTATION#`
  : (state && eocId && conditionId && imageSetId && imageId && imageId !== T) ?                      `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#${imageId}`
  : (state && eocId && conditionId && imageSetId && imageId && imageId === T) ?                      `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}#IMAGE#`
  : (state && eocId && conditionId && imageSetId && imageSetId !== T) ?                           `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#${imageSetId}`
  : (state && eocId && conditionId && imageSetId && imageSetId === T) ?                           `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}#IMAGESET#`
  : (state && eocId && conditionId && conditionId !== T) ?                                              `STATE#${state}#EOC#${eocId}#CONDITION#${conditionId}`
  : (state && eocId && conditionId && conditionId === T) ?                                              `STATE#${state}#EOC#${eocId}#CONDITION#`
  : (state && eocId && eocId !== T) ?                                                                   `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                                                                   `STATE#${state}#EOC#`
  : (state) ?                                                                                           `STATE#${state}`
  :                                                                                                     'STATE#'
  )
};

// ##############
// ---- USER ----
// ##############

const user = {
  pk: `USER${ids.userId}`,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#DATA`,
  buildPk: (userId) => `USER#${userId}`,
  buildSk: (state, userType, userId) =>             `STATE#${state}#USERTYPE#${userType}#USER#${userId}#DATA`,
  buildQuerySk: (state, userType, userId) => (
    (state && userType && userId && userId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?         `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?         `STATE#${state}#USERTYPE#`
  : (state) ?                                       `STATE#${state}`
  :                                                 'STATE#'
  )
};
const users = {
  pk: 'USER',
  sk: user.sk,
  buildPk: () => 'USER',
  buildSk: user.buildSk,
  buildQuerySk: user.buildQuerySk,
};

// ##################
// ---- USER PIN ----
// ##################

const userPin = {
  pk: `USER${ids.userId}#PIN`,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#PIN`,
  buildPk: (userId) => `USER#${userId}`,
  buildSk: (state, userType, userId) =>             `STATE#${state}#USERTYPE#${userType}#USER#${userId}#PIN`,
  buildQuerySk: (state, userType, userId) => (
    (state && userType && userId && userId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?         `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?         `STATE#${state}#USERTYPE#`
  : (state) ?                                       `STATE#${state}`
  :                                                 'STATE#'
  )
};

// #########################
// ---- ACCOUNT SETTING ----
// #########################

const accountSetting = {
  pk: `USER${ids.userId}#ACCOUNTSETTING`,
  sk: `STATE#state#USER#${ids.userId}#ACCOUNTSETTING`,
  buildPk: (userId) => `USER#${userId}#ACCOUNTSETTING`,
  buildSk: (state, userId) =>                       `STATE#${state}#USER#${userId}#ACCOUNTSETTING`,
  buildQuerySk: (state, userId) => (
    (state && userId && userId !== T) ?             `STATE#${state}#USER#${userId}`
  : (state && userId && userId === T) ?             `STATE#${state}#USER#`
  : (state) ?                                       `STATE#${state}`
  :                                                 'STATE#'
  )
};

// #########################
// ---- ACCOUNT SETTING ----
// #########################

const userWalkthrough = {
  pk: `USER${ids.userId}#WALKTHROUGH`,
  sk: `STATE#state#USER#${ids.userId}#WALKTHROUGH`,
  buildPk: (userId) => `USER#${userId}#WALKTHROUGH`,
  buildSk: (state, userId) =>                       `STATE#${state}#USER#${userId}#WALKTHROUGH`,
  buildQuerySk: (state, userId) => (
    (state && userId && userId !== T) ?             `STATE#${state}#USER#${userId}`
  : (state && userId && userId === T) ?             `STATE#${state}#USER#`
  : (state) ?                                       `STATE#${state}`
  :                                                 'STATE#'
  )
};

// #########################
// ---- TEAM ----
// #########################

const team = {
    pk: `ORG${ids.orgId}#TEAMS`,
    sk: `STATE#state#ORG#${ids.orgId}#TEAMS#${ids.teamId}#DATA`,
    buildPk: (orgId) => `ORG#${orgId}#TEAMS`,
    buildSk: (state, orgId, teamId) =>              `STATE#${state}#ORG#${orgId}#TEAMS#${teamId}#DATA`,
    buildQuerySk: (state, orgId, teamId) => (
      (state && orgId && teamId && teamId !== T) ?  `STATE#${state}#ORG#${orgId}#TEAMS#${teamId}`
    : (state && orgId && teamId && teamId === T) ?  `STATE#${state}#ORG#${orgId}#TEAMS#`
    : (state && orgId && orgId !== T) ?             `STATE#${state}#ORG#${orgId}`
    : (state && orgId && orgId === T) ?             `STATE#${state}#ORG#`
    : (state) ?                                     `STATE#${state}`
    :                                               'STATE#'
    )
};

// #######################################
// ---- PROVIDER AP/LP QUALIFICATIONS ----
// #######################################

const userQualification = {
  pk: `USER${ids.userId}#QUALIFICATION`,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#QUALIFICATION#${ids.qualificationId}#DATA`,
  buildPk: (userId) => `USER#${userId}#QUALIFICATION`,
  buildSk: (state, userType, userId, qualificationId) =>                        `STATE#${state}#USERTYPE#${userType}#USER#${userId}#QUALIFICATION#${qualificationId}#DATA`,
  buildQuerySk: (state, userType, userId, qualificationId) => (
    (state && userType && userId && qualificationId && qualificationId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#QUALIFICATION#${qualificationId}`
  : (state && userType && userId && qualificationId && qualificationId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#QUALIFICATION#`
  : (state && userType && userId && userId !== T) ?                             `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ?                             `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?                                     `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?                                     `STATE#${state}#USERTYPE#`
  : (state) ?                                                                   `STATE#${state}`
  :                                                                             'STATE#'
  )
};

// ########################################################
// ---- SCHEDULE SLOT APPOINTMENT APPOINTMENT RESPONSE ----
// ########################################################

const schedule = {
  pk: user.pk,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#SCHEDULE#${ids.scheduleId}#DATA`,
  buildPk: user.buildPk,
  buildSk: (state, userType, userId, scheduleId) =>                   `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#DATA`,
  buildQuerySk: (state, userType, userId, scheduleId) => (
    (state && userType && userId && scheduleId && scheduleId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}`
  : (state && userType && userId && scheduleId && scheduleId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#`
  : (state && userType && userId && userId !== T) ?                   `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ?                   `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?                           `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?                           `STATE#${state}#USERTYPE#`
  : (state) ?                                                         `STATE#${state}`
  :                                                                   'STATE#'
  )
};
const slot = {
  pk: user.pk,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#SCHEDULE#${ids.scheduleId}#SLOT#${ids.slotId}#DATA`,
  buildPk: user.buildPk,
  buildSk: (state, userType, userId, scheduleId, slotId) =>                 `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#DATA`,
  buildQuerySk: (state, userType, userId, scheduleId, slotId) => (
    (state && userType && userId && scheduleId && slotId && slotId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}`
  : (state && userType && userId && scheduleId && slotId && slotId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#`
  : (state && userType && userId && scheduleId && scheduleId !== T) ?       `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}`
  : (state && userType && userId && scheduleId && scheduleId === T) ?       `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#`
  : (state && userType && userId && userId !== T) ?                         `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ?                         `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?                                 `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?                                 `STATE#${state}#USERTYPE#`
  : (state) ?                                                               `STATE#${state}`
  :                                                                         'STATE#'
  )
};
const appointment = {
  pk: user.pk,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#SCHEDULE#${ids.scheduleId}#SLOT#${ids.slotId}#APPOINTMENT#${ids.appointmentId}#DATA`,
  buildPk: user.buildPk,
  buildSk: (state, userType, userId, scheduleId, slotId, appointmentId) =>                          `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}#DATA`,
  buildQuerySk: (state, userType, userId, scheduleId, slotId, appointmentId) => (
    (state && userType && userId && scheduleId && slotId && appointmentId && appointmentId !== T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}`
  : (state && userType && userId && scheduleId && slotId && appointmentId && appointmentId === T) ? `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#`
  : (state && userType && userId && scheduleId && slotId && slotId !== T) ?                         `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}`
  : (state && userType && userId && scheduleId && slotId && slotId === T) ?                         `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#`
  : (state && userType && userId && scheduleId && scheduleId !== T) ?                               `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}`
  : (state && userType && userId && scheduleId && scheduleId === T) ?                               `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#`
  : (state && userType && userId && userId !== T) ?                                                 `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ?                                                 `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?                                                         `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?                                                         `STATE#${state}#USERTYPE#`
  : (state) ?                                                                                       `STATE#${state}`
  :                                                                                                 'STATE#'
  )
};
const appointmentResponse = {
  pk: user.pk,
  sk: `STATE#state#USERTYPE#userType#USER#${ids.userId}#SCHEDULE#${ids.scheduleId}#SLOT#${ids.slotId}#APPOINTMENT#${ids.appointmentId}#RES#${ids.appointmentResponseId}#DATA`,
  buildPk: user.buildPk,
  buildSk: (state, userType, userId, scheduleId, slotId, appointmentId, appointmentResponseId) =>                                     `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}#RES#${appointmentResponseId}#DATA`,
  buildQuerySk: (state, userType, userId, scheduleId, slotId, appointmentId, appointmentResponseId) => (
    (state && userType && userId && scheduleId && slotId && appointmentId && appointmentResponseId && appointmentResponseId !== T) ?  `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}#RES#${appointmentResponseId}`
  : (state && userType && userId && scheduleId && slotId && appointmentId && appointmentResponseId && appointmentResponseId === T) ?  `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}#RES#`
  : (state && userType && userId && scheduleId && slotId && appointmentId && appointmentId !== T) ?                                   `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#${appointmentId}`
  : (state && userType && userId && scheduleId && slotId && appointmentId && appointmentId === T) ?                                   `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}#APPOINTMENT#`
  : (state && userType && userId && scheduleId && slotId && slotId !== T) ?                                                           `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#${slotId}`
  : (state && userType && userId && scheduleId && slotId && slotId === T) ?                                                           `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}#SLOT#`
  : (state && userType && userId && scheduleId && scheduleId !== T) ?                                                                 `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#${scheduleId}`
  : (state && userType && userId && scheduleId && scheduleId === T) ?                                                                 `STATE#${state}#USERTYPE#${userType}#USER#${userId}#SCHEDULE#`
  : (state && userType && userId && userId !== T) ?                                                                                   `STATE#${state}#USERTYPE#${userType}#USER#${userId}`
  : (state && userType && userId && userId === T) ?                                                                                   `STATE#${state}#USERTYPE#${userType}#USER#`
  : (state && userType && userType !== T) ?                                                                                           `STATE#${state}#USERTYPE#${userType}`
  : (state && userType && userType === T) ?                                                                                           `STATE#${state}#USERTYPE#`
  : (state) ?                                                                                                                         `STATE#${state}`
  :                                                                                                                                   'STATE#'
  )
};

// ###################
// ---- WORKSPACE ----
// ###################

const workspace = {
  pk: `WORKSPACE#${ids.workspaceId}`,
  sk: `STATE#state#WORKSPACETYPE#workspaceType#WORKSPACE#${ids.workspaceId}#DATA`,
  buildPk: (workspaceId) => `WORKSPACE#${workspaceId}`,
  buildSk: (state, workspaceType, workspaceId) =>                   `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#DATA`,
  buildQuerySk: (state, workspaceType, workspaceId) => (
    (state && workspaceType && workspaceId && workspaceId !== T) ?  `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}`
  : (state && workspaceType && workspaceId && workspaceId === T) ?  `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#`
  : (state && workspaceType && workspaceType !== T) ?               `STATE#${state}#WORKSPACETYPE#${workspaceType}`
  : (state && workspaceType && workspaceType === T) ?               `STATE#${state}#WORKSPACETYPE#`
  : (state) ?                                                       `STATE#${state}`
  :                                                                 'STATE#'
  )
};

// #################
// ---- CHANNEL ----
// #################

const channel = {
  pk: `WORKSPACE#${ids.workspaceId}#CHANNEL`,
  sk: `STATE#state#WORKSPACETYPE#workspaceType#WORKSPACE#${ids.workspaceId}#CHANNELTYPE#channelType#CHANNEL#${ids.channelId}#DATA`,
  buildPk: (workspaceId) => `WORKSPACE#${workspaceId}#CHANNEL`,
  buildSk: (state, workspaceType, workspaceId, channelType, channelId) =>                   `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#DATA`,
  buildQuerySk: (state, workspaceType, workspaceId, channelType, channelId) => (
    (state && workspaceType && workspaceId && channelType && channelId && channelId!== T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}`
  : (state && workspaceType && workspaceId && channelType && channelId && channelId!== T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#`
  : (state && workspaceType && workspaceId && channelType && channelType !== T) ?           `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}`
  : (state && workspaceType && workspaceId && channelType && channelType === T) ?           `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#`
  : (state && workspaceType && workspaceId && workspaceId!== T) ?                           `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}`
  : (state && workspaceType && workspaceId && workspaceId=== T) ?                           `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#`
  : (state && workspaceType && workspaceType!== T) ?                                        `STATE#${state}#WORKSPACETYPE#${workspaceType}`
  : (state && workspaceType && workspaceType=== T) ?                                        `STATE#${state}#WORKSPACETYPE#`
  : (state) ?                                                                               `STATE#${state}`
  :                                                                                         'STATE#'
  )
};

// ##################
// ---- MESSAGES ----
// ##################

const message = {
  pk: `WORKSPACE#${ids.workspaceId}#CHANNEL#${ids.channelId}#MESSAGE`,
  sk: `STATE#state#WORKSPACETYPE#workspaceType#WORKSPACE#${ids.workspaceId}#CHANNELTYPE#channelType#CHANNEL#${ids.channelId}#MESSAGE#${ids.messageId}#DATA`,
  buildPk: (workspaceId, channelId) => `WORKSPACE#${workspaceId}#CHANNEL#${channelId}#MESSAGE`,
  buildSk: (state, workspaceType, workspaceId, channelType, channelId, messageId) =>                      `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#MESSAGE#${messageId}#DATA`,
  buildQuerySk: (state, workspaceType, workspaceId, channelType, channelId, messageId) => (
    (state && workspaceType && workspaceId && channelType && channelId && messageId && messageId !== T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#MESSAGE#${messageId}`
  : (state && workspaceType && workspaceId && channelType && channelId && messageId && messageId === T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#MESSAGE#`
  : (state && workspaceType && workspaceId && channelType && channelId && channelId !== T) ?              `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}`
  : (state && workspaceType && workspaceId && channelType && channelId && channelId === T) ?              `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#`
  : (state && workspaceType && workspaceId && channelType && channelType === T) ?                         `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}`
  : (state && workspaceType && workspaceId && channelType && channelType === T) ?                         `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#`
  : (state && workspaceType && workspaceId && workspaceId !== T) ?                                        `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}`
  : (state && workspaceType && workspaceId && workspaceId === T) ?                                        `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#`
  : (state && workspaceType && workspaceType !== T) ?                                                     `STATE#${state}#WORKSPACETYPE#${workspaceType}`
  : (state && workspaceType && workspaceType === T) ?                                                     `STATE#${state}#WORKSPACETYPE#`
  : (state) ?                                                                                             `STATE#${state}`
  :                                                                                                       'STATE#'
  )
};

// #####################
// ---- WEBRTC ROOM ----
// #####################

const webRtcRoom = {
  pk: `WEBRTCROOM#${ids.roomId}`,
  sk: user.sk,
  gsiPk: user.sk,
  gsiSk: `WEBRTCROOM#${ids.roomId}`,
  buildPk: (roomId) => `WEBRTCROOM#${roomId}`,
  buildSk: user.buildSk,
  buildGsiPk: user.buildSk,
  buildGsiSk: (roomId) => `WEBRTCROOM#${roomId}`,
  buildQuerySk: user.buildQuerySk,
  buildQueryGsiSk: (roomId) => (
   (roomId) ?             `WEBRTCROOM#${roomId}`
  :                       'WEBRTCROOM#'
  )
};

// #########################
// ---- CONFERENCE ROOM ----
// #########################

const conferenceRoom = {
  pk: `WORKSPACE#${ids.workspaceId}#CHANNEL${ids.channelId}#CONFERENCEROOMS`,
  sk: `STATE#state#WORKSPACETYPE#workspaceType#WORKSPACE#${ids.workspaceId}#CHANNELTYPE#channelType#CHANNEL#${ids.channelId}#CONFERENCEROOMTYPE#conferenceRoomType#CONFERENCEROOM#${ids.conferenceRoomId}DATA`,
  buildPk: (workspaceId, channelId) => `WORKSPACE#${workspaceId}#CHANNEL#${channelId}#CONFERENCEROOMS`,
  buildSk: (state, workspaceType, workspaceId, channelType, channelId, conferenceRoomType, conferenceRoomId) =>                               `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#${conferenceRoomType}#CONFERENCEROOM#${conferenceRoomId}#DATA`,
  buildQuerySk: (state, workspaceType, workspaceId, channelType, channelId, conferenceRoomType, conferenceRoomId) => (
    (state && workspaceType && workspaceId && channelType && channelId && conferenceRoomType && conferenceRoomId && conferenceRoomId !== T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#${conferenceRoomType}#CONFERENCEROOM#${conferenceRoomId}`
  : (state && workspaceType && workspaceId && channelType && channelId && conferenceRoomType && conferenceRoomId && conferenceRoomId === T) ? `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#${conferenceRoomType}#CONFERENCEROOM#`
  : (state && workspaceType && workspaceId && channelType && channelId && conferenceRoomType && conferenceRoomType !== T) ?                   `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#${conferenceRoomType}`
  : (state && workspaceType && workspaceId && channelType && channelId && conferenceRoomType && conferenceRoomType === T) ?                   `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#`
  : (state && workspaceType && workspaceId && channelType && channelId && channelId !== T) ?                                                  `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}`
  : (state && workspaceType && workspaceId && channelType && channelId && channelId === T) ?                                                  `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#`
  : (state && workspaceType && workspaceId && channelType && channelType === T) ?                                                             `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}`
  : (state && workspaceType && workspaceId && channelType && channelType === T) ?                                                             `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#`
  : (state && workspaceType && workspaceId && workspaceId !== T) ?                                                                            `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}`
  : (state && workspaceType && workspaceId && workspaceId === T) ?                                                                            `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#`
  : (state && workspaceType && workspaceType !== T) ?                                                                                         `STATE#${state}#WORKSPACETYPE#${workspaceType}`
  : (state && workspaceType && workspaceType === T) ?                                                                                         `STATE#${state}#WORKSPACETYPE#`
  : (state) ?                                                                                                                                 `STATE#${state}`
  :                                                                                                                                           'STATE#'
  )
};

// ####################################
// ---- CONFERENCE ROOM TRANSCRIPT ----
// ####################################

const conferenceRoomTranscript = {
  pk: `WORKSPACE#${ids.workspaceId}#CHANNEL${ids.channelId}#CONFERENCEROOMTRANSCRIPTS`,
  sk: `STATE#state#WORKSPACETYPE#workspaceType#WORKSPACE#${ids.workspaceId}#CHANNELTYPE#channelType#CHANNEL#${ids.channelId}#CONFERENCEROOMTYPE#conferenceRoomType#CONFERENCEROOM#${ids.conferenceRoomId}TRANSCRIPT`,
  buildPk: (workspaceId, channelId) => `WORKSPACE#${workspaceId}#CHANNEL#${channelId}#CONFERENCEROOMTRANSCRIPTS`,
  buildSk: (state, workspaceType, workspaceId, channelType, channelId, conferenceRoomType, conferenceRoomId) => `STATE#${state}#WORKSPACETYPE#${workspaceType}#WORKSPACE#${workspaceId}#CHANNELTYPE#${channelType}#CHANNEL#${channelId}#CONFERENCEROOMTYPE#${conferenceRoomType}#CONFERENCEROOM#${conferenceRoomId}#TRANSCRIPT`,
  buildQuerySk: conferenceRoom.buildQuerySk,
};

// ##############################
// ---- USER DICTATION ROOMS ----
// ##############################

const dictationRoom = {
  pk: `USER#${ids.userId}#DICTATIONROOMS`,
  sk: `STATE#state#USER#${ids.userId}#DICTATIONROOMS#${ids.dictationRoomId}#DATA`,
  buildPk: (userId) => `USER#${userId}#DICTATIONROOMS`,
  buildSk: (state, userId, dictationRoomId) =>                       `STATE#${state}#USER#${userId}#DICTATIONROOMS#${dictationRoomId}#DATA`,
  buildQuerySk: (state, userId, dictationRoomId) => (
      (state && userId && dictationRoomId && dictationRoomId !== T) ? `STATE#${state}#USER#${userId}#DICTATIONROOMS#${dictationRoomId}`
    : (state && userId && dictationRoomId && dictationRoomId === T) ? `STATE#${state}#USER#${userId}#DICTATIONROOMS#`
    : (state && userId && userId !== T) ?                           `STATE#${state}#USER#${userId}`
    : (state && userId && userId === T) ?                           `STATE#${state}#USER#`
    : (state) ?                                                     `STATE#${state}`
    :                                                               'STATE#'
  )
};

// #######################
// ---- NOTIFICATIONS ----
// #######################

const notification = {
  pk: `USER#${ids.userId}#NOTIFICATION`,
  sk: `STATE#state#USER#${ids.userId}#NOTIFICATION#${ids.notificationId}#DATA`,
  buildPk: (userId) => `USER#${userId}#NOTIFICATIONS`,
  buildSk: (state, userId, notificationId) =>                       `STATE#${state}#USER#${userId}#NOTIFICATION#${notificationId}#DATA`,
  buildQuerySk: (state, userId, notificationId) => (
      (state && userId && notificationId && notificationId !== T) ? `STATE#${state}#USER#${userId}#NOTIFICATION#${notificationId}`
    : (state && userId && notificationId && notificationId === T) ? `STATE#${state}#USER#${userId}#NOTIFICATION#`
    : (state && userId && userId !== T) ?                           `STATE#${state}#USER#${userId}`
    : (state && userId && userId === T) ?                           `STATE#${state}#USER#`
    : (state) ?                                                     `STATE#${state}`
    :                                                               'STATE#'
  )
};

// ##########################
// ---- RESOURCE SHARING ----
// ##########################

const library = {
  pk: `LIBRARY_TYPE#libraryType#LIBRARY#${ids.libraryId}`,
  sk: `STATE#state#LIBRARY_TYPE#libraryType#LIBRARY#${ids.libraryId}#DATA`,
  buildPk: (libraryId) => `LIBRARY_TYPE#libraryType#LIBRARY#${libraryId}`,
  buildSk: (state, libraryType, libraryId) =>                 `STATE#${state}#LIBRARY_TYPE#${libraryType}#LIBRARY#${libraryId}#DATA`,
  buildQuerySk: (state, libraryType, libraryId) => (
    (state && libraryType && libraryId && libraryId !== T) ?  `STATE#${state}#LIBRARY_TYPE#${libraryType}#LIBRARY#${libraryId}`
  : (state && libraryType && libraryId && libraryId === T) ?  `STATE#${state}#LIBRARY_TYPE#${libraryType}#LIBRARY#`
  : (state && libraryType && libraryType !== T) ?             `STATE#${state}#LIBRARY_TYPE#${libraryType}`
  : (state && libraryType && libraryType === T) ?             `STATE#${state}#LIBRARY_TYPE#`
  : (state) ?                                                 `STATE#${state}`
  :                                                           'STATE#'
  )
};
const book = {
  pk: `BOOK#${ids.bookId}`,
  sk: `STATE#state#BOOK#${ids.bookId}#DATA`,
  buildPk: (bookId) => `BOOK#${bookId}`,
  buildSk: (state, bookId) =>           `STATE#${state}#BOOK#${bookId}#DATA`,
  buildQuerySk: (state, bookId) => (
    (state && bookId && bookId !== T) ? `STATE#${state}#BOOK#${bookId}`
  : (state && bookId && bookId === T) ? `STATE#${state}#BOOK#`
  : (state) ?                           `STATE#${state}`
  :                                     'STATE#'
  )
};
const page = {
  pk: `PAGE#${ids.pageId}`,
  sk: `STATE#state#PAGE#${ids.pageId}#DATA`,
  buildPk: (pageId) => `PAGE#${pageId}`,
  buildSk: (state, pageId) =>           `STATE#${state}#PAGE#${pageId}#DATA`,
  buildQuerySk: (state, pageId) => (
    (state && pageId && pageId !== T) ? `STATE#${state}#PAGE#${pageId}`
  : (state && pageId && pageId === T) ? `STATE#${state}#PAGE#`
  : (state) ?                           `STATE#${state}`
  :                                     'STATE#'
  )
};

// ######################
// ---- ORG BRANDING ----
// ######################

const branding = {
  pk: `ORG${ids.orgId}#BRANDING`,
  sk: `STATE#state#ORG#${ids.orgId}#DATA`,
  buildPk: (orgId) => `ORG#${orgId}#DATA`,
  buildSk: (state, orgId) =>          `STATE#${state}#ORG#${orgId}#DATA`,
  buildQuerySk: (state, orgId) => (
    (state && orgId && orgId !== T) ? `STATE#${state}#ORG#${orgId}`
  : (state && orgId && orgId === T) ? `STATE#${state}#ORG#`
  : (state) ?                         `STATE#${state}`
  :                                   'STATE#'
  )
};

// ####################
// ---- ORG CONFIG ----
// ####################

const orgConfig = {
  pk: `ORG${ids.orgId}#CONFIG`,
  sk: `STATE#state#ORG#${ids.orgId}#DATA`,
  buildPk: (orgId) => `ORG#${orgId}#CONFIG`,
  buildSk: (state, orgId) =>          `STATE#${state}#ORG#${orgId}#DATA`,
  buildQuerySk: (state, orgId) => (
    (state && orgId && orgId !== T) ? `STATE#${state}#ORG#${orgId}`
  : (state && orgId && orgId === T) ? `STATE#${state}#ORG#`
  : (state) ?                         `STATE#${state}`
  :                                   'STATE#'
  )
};

// ###########################
// ---- EOC EXPORT RECORD ----
// ###########################

const eocExportRecord = {
  pk: eoc.pk,
  sk: `STATE#state#EOC#${ids.eocId}#EXPORTRECORD#${ids.exportId}#DATA`,
  buildPk: eoc.buildPk,
  buildSk: (state, eocId, exportId) =>                    `STATE#${state}#EOC#${eocId}#EXPORTRECORD#${exportId}#DATA`,
  buildQuerySk: (state, eocId, exportId) => (
    (state && eocId && exportId && exportId !== T) ?          `STATE#${state}#EOC#${eocId}#EXPORTRECORD#${exportId}`
  : (state && eocId && exportId && exportId === T) ?          `STATE#${state}#EOC#${eocId}#EXPORTRECORD#`
  : (state && eocId && eocId !== T) ?                         `STATE#${state}#EOC#${eocId}`
  : (state && eocId && eocId === T) ?                         `STATE#${state}#EOC#`
  : (state) ?                                                 `STATE#${state}`
  :                                                           'STATE#'
  )
};


// ##############
// ---- TAGS ----
// ##############

const tag = {
  pk: 'TAGOWNERTYPE#ownerType#OWNERID#ownerId#TAGTYPE#tagType',
  buildPk: (ownerType, ownerId, tagType) => `TAGOWNERTYPE#${ownerType}#OWNERID#${ownerId}#TAGTYPE#${tagType}`,
};

const pageTag = {
  ...tag,
  sk: page.sk,
  buildSk: page.buildSk,
  buildQuerySk: page.buildQuerySk,
};

const bookTag = {
  ...tag,
  sk: book.sk,
  buildSk: book.buildSk,
  buildQuerySk: book.buildQuerySk,
};

const libraryTag = {
  ...tag,
  sk: library.sk,
  buildSk: library.buildSk,
  buildQuerySk: library.buildQuerySk,
};

const orgTag = {
  ...tag,
  sk: org.sk,
  buildSk: org.buildSk,
  buildQuerySk: org.buildQuerySk,
};

const userTag = {
  ...tag,
  sk: user.sk,
  buildSk: user.buildSk,
  buildQuerySk: user.buildQuerySk,
};

// ########################
// ---- MAPPING TABLES ----
// ########################

const orgsToEocs = {
  pk: `${org.sk.slice(0,-5)}#ORGSTOEOCS`,
  sk: eoc.sk,
  gsiPk: `${eoc.sk.slice(0,-5)}#ORGSTOEOCS`,
  gsiSk: org.sk,

  buildPk: (state, orgId) => `${(org.buildSk(state, orgId)).slice(0,-5)}#ORGSTOEOCS`,
  buildSk: eoc.buildSk,
  buildGsiPk: (state, eocId) => `${(eoc.buildSk(state, eocId)).slice(0,-5)}#ORGSTOEOCS`,
  buildGsiSk: org.buildSk,

  buildQuerySk: eoc.buildQuerySk,
  buildQueryGsiSk: org.buildQuerySk,
};
const orgsToUsers = {
  pk: `${org.sk.slice(0,-5)}#ORGSTOUSERS`,
  sk: user.sk,
  gsiPk: `${user.sk.slice(0,-5)}#ORGSTOUSERS`,
  gsiSk: org.sk,

  buildPk: (state, orgId) => `${(org.buildSk(state, orgId).slice(0,-5))}#ORGSTOUSERS`,
  buildSk: user.buildSk,
  buildGsiPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId)).slice(0,-5)}}#ORGSTOUSERS`,
  buildGsiSk: org.buildSk,

  buildQuerySk: user.buildQuerySk,
  buildQueryGsiSk: org.buildQuerySk,
};
const usersToWorkspaces = {
  pk: `${user.sk.slice(0,-5)}#USERSTOWORKSPACES`,
  sk: workspace.sk,
  gsiPk: `${workspace.sk.slice(0,-5)}#USERSTOWORKSPACES`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOWORKSPACES`,
  buildSk: workspace.buildSk,
  buildGsiPk: (state, workspaceType, workspaceId) => `${(workspace.buildSk(state, workspaceType, workspaceId).slice(0,-5))}#USERSTOWORKSPACES`,
  buildGsiSk: user.buildSk,

  buildQuerySk: workspace.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToChannels = {
  pk: `${user.sk.slice(0,-5)}#USERSTOCHANNELS`,
  sk: channel.sk,
  gsiPk: `${channel.sk.slice(0,-5)}#USERSTOCHANNELS`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOCHANNELS`,
  buildSk: channel.buildSk,
  buildGsiPk: (state, workspaceType, workspaceId, channelType, channelId) => `${(channel.buildSk(state, workspaceType, workspaceId, channelType, channelId).slice(0,-5))}#USERSTOCHANNELS`,
  buildGsiSk: user.buildSk,

  buildQuerySk: channel.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToEocs = {
  pk: `${user.sk.slice(0,-5)}#USERSTOEOCS`,
  sk: eoc.sk,
  gsiPk: `${eoc.sk.slice(0,-5)}#USERSTOEOCS`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOEOCS`,
  buildSk: eoc.buildSk,
  buildGsiPk: (state, eocId) => `${(eoc.buildSk(state, eocId).slice(0,-5))}#USERSTOEOCS`,
  buildGsiSk: user.buildSk,

  buildQuerySk: eoc.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToSchedule = {
  pk: `${user.sk.slice(0,-5)}#USERSTOSCHEDULE`,
  sk: schedule.sk,
  gsiPk: `${schedule.sk.slice(0,-5)}#USERSTOSCHEDULE`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOSCHEDULE`,
  buildSk: schedule.buildSk,
  buildGsiPk: (state, userType, userId, scheduleId) => `${(schedule.buildSk(state, userType, userId, scheduleId).slice(0,-5))}#USERSTOSCHEDULE`,
  buildGsiSk: user.buildSk,

  buildQuerySk: schedule.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToTeams = {
  pk: `${user.sk.slice(0,-5)}#USERSTOTEAMS`,
  sk: team.sk,
  gsiPk: `${team.sk.slice(0,-5)}#USERSTOTEAMS`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOTEAMS`,
  buildSk: team.buildSk,
  buildGsiPk: (state, orgId, teamId) => `${(team.buildSk(state, orgId, teamId).slice(0,-5))}#USERSTOTEAMS`,
  buildGsiSk: user.buildSk,

  buildQuerySk: team.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const eocsToTeams = {
  pk: `${eoc.sk.slice(0,-5)}#EOCSTOTEAMS`,
  sk: team.sk,
  gsiPk: `${team.sk.slice(0,-5)}#EOCSTOTEAMS`,
  gsiSk: eoc.sk,

  buildPk: (state, eocId) => `${(eoc.buildSk(state, eocId).slice(0,-5))}#EOCSTOTEAMS`,
  buildSk: team.buildSk,
  buildGsiPk: (state, orgId, teamId) => `${(team.buildSk(state, orgId, teamId).slice(0,-5))}#EOCSTOTEAMS`,
  buildGsiSk: eoc.buildSk,

  buildQuerySk: team.buildQuerySk,
  buildQueryGsiSk: eoc.buildQuerySk,
};
const usersToPages = {
  pk: `${user.sk.slice(0,-5)}#USERSTOPAGES`,
  sk: page.sk,
  gsiPk: `${page.sk.slice(0,-5)}#USERSTOPAGES`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOPAGES`,
  buildSk: page.buildSk,
  buildGsiPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#USERSTOPAGES`,
  buildGsiSk: user.buildSk,

  buildQuerySk: page.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToBooks = {
  pk: `${user.sk.slice(0,-5)}#USERSTOBOOKS`,
  sk: book.sk,
  gsiPk: `${book.sk.slice(0,-5)}#USERSTOBOOKS`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOBOOKS`,
  buildSk: book.buildSk,
  buildGsiPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#USERSTOBOOKS`,
  buildGsiSk: user.buildSk,

  buildQuerySk: book.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const usersToLibraries = {
  pk: `${user.sk.slice(0,-5)}#USERSTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#USERSTOLIBRARIES`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#USERSTOLIBRARIES`,
  buildGsiSk: user.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};
const teamsToPages = {
  pk: `${team.sk.slice(0,-5)}#TEAMSTOPAGES`,
  sk: page.sk,
  gsiPk: `${page.sk.slice(0,-5)}#TEAMSTOPAGES`,
  gsiSk: team.sk,

  buildPk: (state, orgId, teamId) => `${(team.buildSk(state, orgId, teamId).slice(0,-5))}#TEAMSTOPAGES`,
  buildSk: page.buildSk,
  buildGsiPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#TEAMSTOPAGES`,
  buildGsiSk: team.buildSk,

  buildQuerySk: page.buildQuerySk,
  buildQueryGsiSk: team.buildQuerySk,
};
const teamsToBooks = {
  pk: `${team.sk.slice(0,-5)}#TEAMSTOBOOKS`,
  sk: book.sk,
  gsiPk: `${book.sk.slice(0,-5)}#TEAMSTOBOOKS`,
  gsiSk: team.sk,

  buildPk: (state, orgId, teamId) => `${(team.buildSk(state, orgId, teamId).slice(0,-5))}#TEAMSTOBOOKS`,
  buildSk: book.buildSk,
  buildGsiPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#TEAMSTOBOOKS`,
  buildGsiSk: team.buildSk,

  buildQuerySk: book.buildQuerySk,
  buildQueryGsiSk: team.buildQuerySk,
};
const teamsToLibraries = {
  pk: `${team.sk.slice(0,-5)}#TEAMSTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#TEAMSTOLIBRARIES`,
  gsiSk: team.sk,

  buildPk: (state, orgId, teamId) => `${(team.buildSk(state, orgId, teamId).slice(0,-5))}#TEAMSTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#TEAMSTOLIBRARIES`,
  buildGsiSk: team.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: team.buildQuerySk,
};
const eocsToPages = {
  pk: `${eoc.sk.slice(0,-5)}#EOCSTOPAGES`,
  sk: page.sk,
  gsiPk: `${page.sk.slice(0,-5)}#EOCSTOPAGES`,
  gsiSk: eoc.sk,

  buildPk: (state, eocId) => `${(eoc.buildSk(state, eocId).slice(0,-5))}#EOCSTOPAGES`,
  buildSk: page.buildSk,
  buildGsiPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#EOCSTOPAGES`,
  buildGsiSk: eoc.buildSk,

  buildQuerySk: page.buildQuerySk,
  buildQueryGsiSk: eoc.buildQuerySk,
};
const eocsToBooks = {
  pk: `${eoc.sk.slice(0,-5)}#EOCSTOBOOKS`,
  sk: book.sk,
  gsiPk: `${book.sk.slice(0,-5)}#EOCSTOBOOKS`,
  gsiSk: eoc.sk,

  buildPk: (state, eocId) => `${(eoc.buildSk(state, eocId).slice(0,-5))}#EOCSTOBOOKS`,
  buildSk: book.buildSk,
  buildGsiPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#EOCSTOBOOKS`,
  buildGsiSk: eoc.buildSk,

  buildQuerySk: book.buildQuerySk,
  buildQueryGsiSk: eoc.buildQuerySk,
};
const eocsToLibraries = {
  pk: `${eoc.sk.slice(0,-5)}#EOCSTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#EOCSTOLIBRARIES`,
  gsiSk: eoc.sk,

  buildPk: (state, eocId) => `${(eoc.buildSk(state, eocId).slice(0,-5))}#EOCSTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#EOCSTOLIBRARIES`,
  buildGsiSk: eoc.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: eoc.buildQuerySk,
};
const orgsToPages = {
  pk: `${org.sk.slice(0,-5)}#ORGSTOPAGES`,
  sk: page.sk,
  gsiPk: `${page.sk.slice(0,-5)}#ORGSTOPAGES`,
  gsiSk: org.sk,

  buildPk: (state, orgId) => `${(org.buildSk(state, orgId).slice(0,-5))}#ORGSTOPAGES`,
  buildSk: page.buildSk,
  buildGsiPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#ORGSTOPAGES`,
  buildGsiSk: org.buildSk,

  buildQuerySk: page.buildQuerySk,
  buildQueryGsiSk: org.buildQuerySk,
};
const orgsToBooks = {
  pk: `${org.sk.slice(0,-5)}#ORGSTOBOOKS`,
  sk: book.sk,
  gsiPk: `${book.sk.slice(0,-5)}#ORGSTOBOOKS`,
  gsiSk: org.sk,

  buildPk: (state, orgId) => `${(org.buildSk(state, orgId).slice(0,-5))}#ORGSTOBOOKS`,
  buildSk: book.buildSk,
  buildGsiPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#ORGSTOBOOKS`,
  buildGsiSk: org.buildSk,

  buildQuerySk: book.buildQuerySk,
  buildQueryGsiSk: org.buildQuerySk,
};
const orgsToLibraries = {
  pk: `${org.sk.slice(0,-5)}#ORGSTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#ORGSTOLIBRARIES`,
  gsiSk: org.sk,

  buildPk: (state, orgId) => `${(org.buildSk(state, orgId).slice(0,-5))}#ORGSTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#ORGSTOLIBRARIES`,
  buildGsiSk: org.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: org.buildQuerySk,
};
const pagesToBooks = {
  pk: `${page.sk.slice(0,-5)}#PAGESTOBOOKS`,
  sk: book.sk,
  gsiPk: `${book.sk.slice(0,-5)}#PAGESTOBOOKS`,
  gsiSk: page.sk,

  buildPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#PAGESTOBOOKS`,
  buildSk: book.buildSk,
  buildGsiPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#PAGESTOBOOKS`,
  buildGsiSk: page.buildSk,

  buildQuerySk: book.buildQuerySk,
  buildQueryGsiSk: page.buildQuerySk,
};
const pagesToLibraries = {
  pk: `${page.sk.slice(0,-5)}#PAGESTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#PAGESTOLIBRARIES`,
  gsiSk: page.sk,

  buildPk: (state, pageId) => `${(page.buildSk(state, pageId).slice(0,-5))}#PAGESTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#PAGESTOLIBRARIES`,
  buildGsiSk: page.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: page.buildQuerySk,
};
const booksToLibraries = {
  pk: `${book.sk.slice(0,-5)}#BOOKSTOLIBRARIES`,
  sk: library.sk,
  gsiPk: `${library.sk.slice(0,-5)}#BOOKSTOLIBRARIES`,
  gsiSk: book.sk,

  buildPk: (state, bookId) => `${(book.buildSk(state, bookId).slice(0,-5))}#BOOKSTOLIBRARIES`,
  buildSk: library.buildSk,
  buildGsiPk: (state, libraryType, libraryId) => `${(library.buildSk(state, libraryType, libraryId).slice(0,-5))}#BOOKSTOLIBRARIES`,
  buildGsiSk: book.buildSk,

  buildQuerySk: library.buildQuerySk,
  buildQueryGsiSk: book.buildQuerySk,
};

const usersToConferenceRooms = {
  pk: `${user.sk.slice(0,-5)}#USERSTOCONFERENCEROOMS`,
  sk: conferenceRoom.sk,
  gsiPk: `${conferenceRoom.sk.slice(0,-5)}#USERSTOCONFERENCEROOMS`,
  gsiSk: user.sk,

  buildPk: (state, userType, userId) => `${(user.buildSk(state, userType, userId).slice(0,-5))}#USERSTOCONFERENCEROOMS`,
  buildSk: conferenceRoom.buildSk,
  buildGsiPk: (state, workspaceType, workspaceId, channelType, channelId, conferenceRoomId) => `${(conferenceRoom.buildSk(state, workspaceType, workspaceId, channelType, channelId, conferenceRoomId).slice(0,-5))}#USERSTOCONFERENCEROOMS`,
  buildGsiSk: user.buildSk,

  buildQuerySk: conferenceRoom.buildQuerySk,
  buildQueryGsiSk: user.buildQuerySk,
};

// ###################################
// ---- USER WEBSOCKET CONNECTION ----
// ###################################

const userWebsocketConnection = {
  pk: user.pk,
  sk: 'STATE#state#DATA',
  gsiPk: `SUB#${ids.userSub}`,
  gsiSk: 'STATE#state#DATA',
  buildPk: user.buildPk,
  buildSk: (state) => `STATE#${state}#DATA`,
  buildGsiPk: (userSub) => `SUB#${userSub}`,
  buildGsiSk: (state) => `STATE#${state}#DATA`,
  buildQuerySk: (state) => `STATE#${state}`,
  buildQueryGsiSk: (state) => `STATE#${state}`,
};

const identifiers = {
  authUser,
  authRefreshToken,
  authForgotPasswordToken,
  authSessionToken,
  org,
  orgs,
  eoc,
  eocs,
  eocAnnotation,
  condition,
  conditionAnnotation,
  clinicalImpression,
  clinicalImpressionAnnotation,
  bodySite,
  bodySiteAnnotation,
  imageSet,
  image,
  imageAnnotation,
  user,
  userQualification,
  users,
  schedule,
  slot,
  appointment,
  appointmentResponse,
  workspace,
  channel,
  message,
  notification,
  userPin,
  accountSetting,
  team,
  branding,
  orgConfig,
  eocExportRecord,
  userWalkthrough,
  // Mapping
  orgsToEocs,
  orgsToUsers,
  usersToChannels,
  usersToWorkspaces,
  usersToEocs,
  usersToSchedule,
  usersToTeams,
  eocsToTeams,
  usersToPages,
  usersToBooks,
  usersToLibraries,
  teamsToPages,
  teamsToBooks,
  teamsToLibraries,
  eocsToPages,
  eocsToBooks,
  eocsToLibraries,
  orgsToPages,
  orgsToBooks,
  orgsToLibraries,
  pagesToBooks,
  pagesToLibraries,
  booksToLibraries,
  // Websockets
  userWebsocketConnection,
  // WebRTC
  webRtcRoom,
  conferenceRoom,
  conferenceRoomTranscript,
  usersToConferenceRooms,
  dictationRoom,
  // Tags
  userTag,
  orgTag,
  pageTag,
  bookTag,
  libraryTag,
  // Resource Sharing
  library,
  book,
  page
};

const joiValidateObj = function (schema, obj) {
  const validationSchema = Joi.object().keys( schema );
  const validation = validationSchema.validate(obj);
  if (validation.error) {
    throw {
      httpStatusCode: StatusCodes.BAD_REQUEST,
      message: validation.error.message
    };
  }
};

exports.ids = ids;
exports.identifiers = identifiers;
exports.joiValidateObj = joiValidateObj;